import { sortBy } from "helpers";
import React, { useMemo } from "react";

const useDataTableRows = (rows = [], sortModel = { fields: "", sort: "" }) => {
    const data = useMemo(() => {
        let iterator = 1;
        let tmp = (rows || []).map((r) => ({ ...r, index: iterator++ }));
        if (sortModel && sortModel.fields) {
            tmp = sortBy(tmp, sortModel.fields, sortModel.sort);
        }
        return tmp;
    }, [rows, sortModel]);
    return data;
};

export default useDataTableRows;
